import ProductInventoryPriceAPICall from "../service/ProductInventoryPriceAPICall";
import store from "../storeWire";
import { setInventory, setPricingList } from "src/store/slice/model/ProductInventoryPrice";
import { __remove, __set } from "src/store/axios_indicator";
import { chunk, isArray } from "underscore";
import Constants from "src/helper/Constants";
import System from "src/helper/system";
const { currencyType: { USD }, speedBoats: { apacAbbr }, } = Constants;
class ProductInventoryPriceRepository {

    getInventoryParams = (product) => {
        let param = {
            ItemNumber: product?.ItemNumber,
            ERPPartNumber: product?.ERPPartNumber,
            manufacturerCode: product?.ManufacturerCode
            // manufacturerCode: product?.ERPManufacturerCode
        };
        return param
    }

    setinventoryState = (obj) => {
        let master_data = {};
        if (store) {
            let storeIn = store.getState();
            master_data = storeIn.entities.model_ProductInventoryPrice.inventory_list;
        }
        let data = { ...master_data, ...obj }
        store.dispatch(setInventory(data));
    }

    getInventory = async (params, isFrom = '') => {
        __set('PRODUCT_INVENTORY_API_CALL');
        const resObj = {}

        if (params && params.length) {
            const data = {
                salesOrderLineItems: params
            }

            const res = await new ProductInventoryPriceAPICall().getInventory(data);
            let storeIn = store.getState();

            if (res.isSuccessFull && res.data) {
                res.data?.salesOrderLineItems?.map(v => {
                    const matchedItem = params.find(p => p.ERPPartNumber === v.erpPartNumber);
                    
                    const productDataStock = storeIn.entities.model_ProductListing.master_data_only_products_list[matchedItem?.ItemNumber]?.Stock
                    
                    const compareDataStock = storeIn.entities.model_ProductCompare.data[matchedItem?.ItemNumber]?.Stock
                    const stockInventory = productDataStock || compareDataStock || 0

                    resObj[matchedItem.ItemNumber] = { inventoryQty: stockInventory, inventory: v.availableQuantity ? parseInt(v.availableQuantity) : 0, totalInventory: stockInventory + Number(v.availableQuantity) }
                })
            }
            if (resObj && Object.entries(resObj).length)
                this.setinventoryState(resObj)
        }
        __remove('PRODUCT_INVENTORY_API_CALL');
    }

    getPricingParams(params) {
        if (params?.AllocationFlag || params?.PIMBlock?.toUpperCase() === 'E' || params?.QtyMin <= 0 || params?.QtyMult <= 0) {
            return false;
        } else {
            let params_single = {
                uniqueId: params.uniqueId,
                SAPMATERIAL: params?.ERPPartNumber,
                CUSTMATNUM: params?.CPN ? params?.CPN : '',
                MFRPARTNUMBER: params?.ERPMFRPartNumber,
                // MANUFACTURER: params?.ManufacturerCode,
                MANUFACTURER: params?.ERPManufacturerCode,
                ItemNumber: params?.ItemNumber,
            }
            return params_single
        }
    };

    getExchangeRate = async (params) => {
        if (System.getCurrentRegionWithType(apacAbbr) && window.mct != USD) {
            params = { ...params, targetCurrency: USD, exchangeRateDate: new Date().toJSON().slice(0, 10).replace(/-/g, '-') }
            return await new ProductInventoryPriceAPICall().getExchangeRate(params)
        }
        return 1;
    };

    getPricingList = async (params, noStateSet = true, currency = window.mct) => {
        let resObj = {}
        if (params && params.length) {

            // let exChangeRate = 1;
            // if (window.mct !== USD) {
            const exChangeRate = await new ProductInventoryPriceRepository().getExchangeRate({ inputCurrency: currency })
            // }

            let chunkParam = chunk(params, 5);

            await Promise.all(chunkParam.map(async (ele) => {
                let priceRes = await new ProductInventoryPriceAPICall().getPricingList(ele, currency)

                let res = {}
                priceRes?.map?.((v, i) => {
                    const { scalesList, sapMaterial, promotionPrice, custPriceInd, taxIncludedPrice, ...rest } = v;


                    const pricingData = scalesList.map((obj) => {
                        const { minScaleQty, price, ...rest } = obj;
                        return {
                            marketPrice: exChangeRate * Number(price),
                            USDmarketPrice: Number(price),
                            quantity: Number(minScaleQty),
                            taxIncludedPrice: Number(taxIncludedPrice),
                            promotionPrice: promotionPrice === 'Y' ? true : false,
                            custPriceInd: custPriceInd === 'Y' ? true : false,
                            ...rest
                        };
                    });

                    // remove which have no market price and set in quantity ascending order also filter by selected currency
                    let pricing = pricingData
                        .filter(item => item.marketPrice && item.marketPrice !== 0)
                        .sort((a, b) => a.quantity - b.quantity);

                    let items = params.filter(f => f.SAPMATERIAL === sapMaterial)
                    // if (customerPartNum) {
                    //     items = params.filter(f => f.SAPMATERIAL === sapMaterial && f.CUSTMATNUM === customerPartNum)
                    // }

                    if (items && items?.length > 0) {
                        items.forEach(ele => {
                            const _id = ele.uniqueId;
                            const ItemNumber = ele.ItemNumber;

                            if (_id) {
                                res[_id] = {
                                    ...rest,
                                    pricing,
                                    ItemNumber: ItemNumber
                                }
                            }

                            res[ItemNumber] = {
                                ...rest,
                                pricing,
                                ItemNumber: ItemNumber
                            }
                        });
                    }

                })

                resObj = res;
                if (res && Object.entries(res).length && noStateSet) {
                    this.setPricingState(res)
                }
            }))
        }

        return resObj;
    }

    setPricingState = (obj) => {
        let master_data = {};
        if (store) {
            let storeIn = store.getState();
            master_data = storeIn.entities.model_ProductInventoryPrice.pricing_list;
        }
        let data = { ...master_data, ...obj }
        store.dispatch(setPricingList(data))
    }

    getCurrentPriceByQuantityAndPriceArray = (single_product_pricing_list, QuantityToCart, first_tir_price = false) => {

        let current_value_final = 0;
        if (single_product_pricing_list && isArray(single_product_pricing_list) && single_product_pricing_list.length > 0) {
            if (single_product_pricing_list.length === 1) {
                if (single_product_pricing_list[0].quantity <= QuantityToCart)
                    current_value_final = single_product_pricing_list[0]
            } else {
                single_product_pricing_list.map((current_value, current_index) => {
                    if (current_value_final === 0) {
                        if (single_product_pricing_list.length === current_index + 1) {
                            if (QuantityToCart >= current_value.quantity) {
                                current_value_final = current_value;
                            }
                        } else {
                            const next_price = single_product_pricing_list[current_index + 1];
                            if ((current_value.quantity === QuantityToCart) ||
                                (current_value.quantity < QuantityToCart && next_price.quantity > QuantityToCart)) {
                                current_value_final = current_value;
                            }
                        }
                    }
                });
            }
            if (current_value_final === 0 && first_tir_price) {
                current_value_final = single_product_pricing_list[0];
            }
        }

        return current_value_final;
    };
}

export default ProductInventoryPriceRepository;